import brand from "./brand";

const link = {
  en: {
    homepage: "Myfitsociety | #1 Best Fitness & Diet App For Body Goals",
    articles: `Articles - ${brand.mobile.mfs}`,
    articleCategory: (categoryName) => (categoryName
      ? `${categoryName} Articles - ${brand.mobile.mfs}`
      : `Article List - ${brand.mobile.mfs}`),
    articleDetail: (articleTitle) => `${articleTitle} - ${brand.mobile.mfs}`,
    aboutUs: `About - ${brand.mobile.mfs}`,
    termsOfUse: `Terms of Use - ${brand.mobile.mfs}`,
    privacyPolicy: `Privacy Policy - ${brand.mobile.mfs}`,
    contactUs: `Contact Us - ${brand.mobile.mfs}`,
    accountVerified: `Account Verification - ${brand.mobile.mfs}`,
    changePassword: `Change Password - ${brand.mobile.mfs}`,
    changeEmail: `Change Email - ${brand.mobile.mfs}`,
    downloadApp: `Download the App - ${brand.mobile.mfs}`,
    tools: `Tools - ${brand.mobile.mfs}`,
    bodyfatCalculator: `Body Fat Calculator - ${brand.mobile.mfs}`,
    bmiCalculator: `BMI Calculator - ${brand.mobile.mfs}`,
    tdeeCalculator: `TDEE Calculator - ${brand.mobile.mfs}`,
    foodDatabase: `Food Database - ${brand.mobile.mfs}`,
    cookingVideos: `Cooking Videos - ${brand.mobile.mfs}`,
    affiliate: `Affiliate Program - ${brand.mobile.mfs}`,
    reseller: `Reseller Program - ${brand.mobile.mfs}`,
    freePremium: `Free Premium - ${brand.mobile.mfs}`,
    point: `Points - ${brand.mobile.mfs}`,
    packageList: `Packages - ${brand.mobile.mfs}`,
    business: `Myfitsociety for Business - ${brand.mobile.mfs}`,
    businessSignin: `Business Login - ${brand.mobile.mfs}`,
    businessRegister: `Register Business - ${brand.mobile.mfs}`,
    businessForgotPassword: `Forgot Password - ${brand.mobile.mfs}`,
    businessOtp: `Business OTP - ${brand.mobile.mfs}`,
    businessList: `Business List - ${brand.mobile.mfs}`,
    businessDetail: `Business Detail - ${brand.mobile.mfs}`,
    businessDiscover: `Discover Businesses - ${brand.mobile.mfs}`,
    businessAddPhotos: `Add Business Photos - ${brand.mobile.mfs}`,
    businessEditProfile: `Edit Business Profile - ${brand.mobile.mfs}`,
    challenge: `Challenge - ${brand.mobile.mfs}`,
    challengeParticipate: `Challenge Participation - ${brand.mobile.mfs}`,
    challengeWinner: `Challenge Winners - ${brand.mobile.mfs}`,
    collabGetPlan: `Your Plan is Ready - ${brand.mobile.mfs}`,
    collabPackageList: `Choose Your Plan - ${brand.mobile.mfs}`,
    collabVoucher: `Collaboration - ${brand.mobile.mfs}`,
    unsubscribe: `Unsubscribe - ${brand.mobile.mfs}`,
    forgeRedeem: `Forge Redeem - ${brand.mobile.mfs}`,
    shareWorkout: `Share Workout - ${brand.mobile.mfs}`,
    cookiePolicy: `Cookie Policy - ${brand.mobile.mfs}`,
    gdprPolicy: `GDPR Compliance - ${brand.mobile.mfs}`,
    refundPolicy: `Refund Policy - ${brand.mobile.mfs}`,
    affiliateTerms: `Affiliate Terms and Conditions - ${brand.mobile.mfs}`,
    resellerTerms: `Reseller Terms - ${brand.mobile.mfs}`,
    consumerHealthDataPrivacy: `Consumer Health Data Privacy - ${brand.mobile.mfs}`,
    nevadaHealthDataPolicy: `Nevada Health Data Policy - ${brand.mobile.mfs}`,
    successStoryTerms: `Success Story Terms and Conditions - ${brand.mobile.mfs}`,
    bogoTerms: `BOGO Terms and Conditions - ${brand.mobile.mfs}`,
    desc: {
      homepage: "Achieve your body goals easier. Access 150+ quick workouts, diet program, and meditation all in one app.",
      articles: "Fitness, diet, and healthy-living articles from Myfitsociety — workout tips, nutrition guides, and wellness advice.",
      articleCategory: "Browse Myfitsociety articles by category — workout tips, diet guides, and healthy living.",
      tools: "Free fitness tools from Myfitsociety — BMI, body fat, and TDEE calculators to plan your training and diet.",
      bmiCalculator: "Calculate your Body Mass Index (BMI) instantly with Myfitsociety's free BMI calculator.",
      bodyfatCalculator: "Estimate your body fat percentage with Myfitsociety's free body fat calculator.",
      tdeeCalculator: "Calculate your Total Daily Energy Expenditure (TDEE) and plan your daily calories with Myfitsociety.",
      foodDatabase: "Look up calories and nutrition for everyday foods in the Myfitsociety food database.",
      cookingVideos: "Healthy cooking videos — quick, nutritious recipe tutorials for your diet program.",
      aboutUs: "Learn about Myfitsociety — the fitness and diet app that helps you reach your body goals.",
      contactUs: "Get in touch with the Myfitsociety team — questions, feedback, and support.",
      termsOfUse: "Read the Terms of Use for the Myfitsociety website and app.",
      privacyPolicy: "Read Myfitsociety's Privacy Policy — how we collect, use, and protect your personal data.",
      cookiePolicy: "Read Myfitsociety's Cookie Policy — how and why we use cookies on this website.",
      gdprPolicy: "Read how Myfitsociety handles personal data in line with GDPR data-protection rules.",
      refundPolicy: "Read Myfitsociety's Refund Policy for premium subscriptions and purchases.",
      affiliateTerms: "Read the Terms and Conditions of the Myfitsociety affiliate program.",
      resellerTerms: "Read the Terms of the Myfitsociety reseller program.",
      consumerHealthDataPrivacy: "Read Myfitsociety's Consumer Health Data Privacy statement.",
      nevadaHealthDataPolicy: "Read Myfitsociety's Nevada Health Data Policy.",
      successStoryTerms: "Read the Terms and Conditions for Myfitsociety success stories.",
      bogoTerms: "Read the Terms and Conditions of Myfitsociety's BOGO (buy one get one) offer.",
      shareWorkout: "Share your Myfitsociety workout with friends.",
      affiliate: "Join the Myfitsociety affiliate program and earn commission promoting the fitness and diet app.",
      reseller: "Become a Myfitsociety reseller — offer premium fitness memberships to your customers.",
      freePremium: "Claim free Myfitsociety Premium — workouts, diet programs, and meditation in one app.",
      challenge: "Join Myfitsociety fitness challenges — complete workouts, climb the leaderboard, and win prizes.",
      point: "Collect Myfitsociety points from workouts and activities and unlock rewards.",
      packageList: "Choose a Myfitsociety package — flexible premium plans for workouts and diet programs.",
      businessList: "Browse businesses partnered with Myfitsociety.",
      businessDiscover: "Discover businesses and partners on Myfitsociety.",
      businessDetail: "Business profile on Myfitsociety.",
      collabGetPlan: "Your Myfitsociety plan is ready — see the workout and diet program built for you.",
      collabPackageList: "Choose your Myfitsociety plan — exclusive partner pricing.",
    },
    underMaintenance: `Under Maintenance - ${brand.mobile.mfs}`,
    appDownload: `Download Myfitsociety - ${brand.mobile.mfs}`,
    workout: `Workout - ${brand.mobile.mfs}`,
  },
  id: {
    homepage: "Myfitsociety | #1 Aplikasi Fitnes & Diet Untuk Body Goals",
    articles: `Artikel - ${brand.mobile.mfs}`,
    articleCategory: (categoryName) => (categoryName
      ? `Artikel ${categoryName} - ${brand.mobile.mfs}`
      : `Daftar Artikel - ${brand.mobile.mfs}`),
    articleDetail: (articleTitle) => `${articleTitle} - ${brand.mobile.mfs}`,
    aboutUs: `Tentang Kami - ${brand.mobile.mfs}`,
    termsOfUse: `Ketentuan Pengunaan - ${brand.mobile.mfs}`,
    privacyPolicy: `Kebijakan Privasi - ${brand.mobile.mfs}`,
    contactUs: `Kontak Kami - ${brand.mobile.mfs}`,
    accountVerified: `Verifikasi Akun - ${brand.mobile.mfs}`,
    changePassword: `Ubah Password - ${brand.mobile.mfs}`,
    changeEmail: `Ubah Email - ${brand.mobile.mfs}`,
    downloadApp: `Download aplikasi - ${brand.mobile.mfs}`,
    tools: `Timer & Kalkulator - ${brand.mobile.mfs}`,
    bodyfatCalculator: `Kalkulator Lemak Tubuh - ${brand.mobile.mfs}`,
    bmiCalculator: `Kalkulator IMT / BMI - ${brand.mobile.mfs}`,
    tdeeCalculator: `Kalkulator TDEE - ${brand.mobile.mfs}`,
    foodDatabase: `Database Makanan - ${brand.mobile.mfs}`,
    cookingVideos: `Video Masak - ${brand.mobile.mfs}`,
    affiliate: `Program Afiliasi - ${brand.mobile.mfs}`,
    reseller: `Program Reseller - ${brand.mobile.mfs}`,
    freePremium: `Premium Gratis - ${brand.mobile.mfs}`,
    point: `Poin - ${brand.mobile.mfs}`,
    packageList: `Paket - ${brand.mobile.mfs}`,
    business: `Myfitsociety untuk Bisnis - ${brand.mobile.mfs}`,
    businessSignin: `Login Bisnis - ${brand.mobile.mfs}`,
    businessRegister: `Daftar Bisnis - ${brand.mobile.mfs}`,
    businessForgotPassword: `Lupa Password - ${brand.mobile.mfs}`,
    businessOtp: `OTP Bisnis - ${brand.mobile.mfs}`,
    businessList: `Daftar Bisnis - ${brand.mobile.mfs}`,
    businessDetail: `Detail Bisnis - ${brand.mobile.mfs}`,
    businessDiscover: `Jelajahi Bisnis - ${brand.mobile.mfs}`,
    businessAddPhotos: `Tambah Foto Bisnis - ${brand.mobile.mfs}`,
    businessEditProfile: `Edit Profil Bisnis - ${brand.mobile.mfs}`,
    challenge: `Tantangan - ${brand.mobile.mfs}`,
    challengeParticipate: `Partisipasi Tantangan - ${brand.mobile.mfs}`,
    challengeWinner: `Pemenang Tantangan - ${brand.mobile.mfs}`,
    collabGetPlan: `Programmu Sudah Siap - ${brand.mobile.mfs}`,
    collabPackageList: `Pilih Programmu - ${brand.mobile.mfs}`,
    collabVoucher: `Kolaborasi - ${brand.mobile.mfs}`,
    unsubscribe: `Berhenti Berlangganan - ${brand.mobile.mfs}`,
    forgeRedeem: `Forge Redeem - ${brand.mobile.mfs}`,
    shareWorkout: `Bagikan Olahraga - ${brand.mobile.mfs}`,
    cookiePolicy: `Kebijakan Cookie - ${brand.mobile.mfs}`,
    gdprPolicy: `Kepatuhan GDPR - ${brand.mobile.mfs}`,
    refundPolicy: `Kebijakan Refund - ${brand.mobile.mfs}`,
    affiliateTerms: `Syarat & Ketentuan Afiliasi - ${brand.mobile.mfs}`,
    resellerTerms: `Syarat Reseller - ${brand.mobile.mfs}`,
    consumerHealthDataPrivacy: `Privasi Data Kesehatan Konsumen - ${brand.mobile.mfs}`,
    nevadaHealthDataPolicy: `Kebijakan Data Kesehatan Nevada - ${brand.mobile.mfs}`,
    successStoryTerms: `Syarat & Ketentuan Success Story - ${brand.mobile.mfs}`,
    bogoTerms: `Syarat & Ketentuan BOGO - ${brand.mobile.mfs}`,
    desc: {
      homepage: "Dapatkan body goals dengan mudah! Akses 150+ olahraga singkat, program diet, dan meditasi hanya dalam satu aplikasi!",
      articles: "Artikel fitnes, diet, dan hidup sehat dari Myfitsociety — tips olahraga, panduan nutrisi, dan gaya hidup sehat.",
      articleCategory: "Jelajahi artikel Myfitsociety per kategori — tips olahraga, panduan diet, dan hidup sehat.",
      tools: "Tools fitnes gratis dari Myfitsociety — kalkulator BMI, lemak tubuh, dan TDEE untuk merencanakan olahraga dan dietmu.",
      bmiCalculator: "Hitung Body Mass Index (BMI/IMT) kamu seketika dengan kalkulator BMI gratis Myfitsociety.",
      bodyfatCalculator: "Perkirakan persentase lemak tubuhmu dengan kalkulator lemak tubuh gratis Myfitsociety.",
      tdeeCalculator: "Hitung Total Daily Energy Expenditure (TDEE) dan rencanakan kalori harianmu dengan Myfitsociety.",
      foodDatabase: "Cari kalori dan nutrisi makanan sehari-hari di database makanan Myfitsociety.",
      cookingVideos: "Video masak sehat — tutorial resep cepat dan bergizi untuk program dietmu.",
      aboutUs: "Kenali Myfitsociety — aplikasi fitnes dan diet yang membantumu mencapai body goals.",
      contactUs: "Hubungi tim Myfitsociety — pertanyaan, masukan, dan bantuan.",
      termsOfUse: "Baca Ketentuan Penggunaan situs dan aplikasi Myfitsociety.",
      privacyPolicy: "Baca Kebijakan Privasi Myfitsociety — bagaimana kami mengumpulkan, memakai, dan melindungi data pribadimu.",
      cookiePolicy: "Baca Kebijakan Cookie Myfitsociety — bagaimana dan mengapa kami memakai cookie di situs ini.",
      gdprPolicy: "Baca bagaimana Myfitsociety mengelola data pribadi sesuai aturan perlindungan data GDPR.",
      refundPolicy: "Baca Kebijakan Refund Myfitsociety untuk langganan dan pembelian premium.",
      affiliateTerms: "Baca Syarat & Ketentuan program afiliasi Myfitsociety.",
      resellerTerms: "Baca Syarat program reseller Myfitsociety.",
      consumerHealthDataPrivacy: "Baca pernyataan Privasi Data Kesehatan Konsumen Myfitsociety.",
      nevadaHealthDataPolicy: "Baca Kebijakan Data Kesehatan Nevada Myfitsociety.",
      successStoryTerms: "Baca Syarat & Ketentuan success story Myfitsociety.",
      bogoTerms: "Baca Syarat & Ketentuan penawaran BOGO (beli satu gratis satu) Myfitsociety.",
      shareWorkout: "Bagikan olahragamu di Myfitsociety ke teman-teman.",
      affiliate: "Gabung program afiliasi Myfitsociety dan dapatkan komisi dengan mempromosikan aplikasi fitnes dan diet.",
      reseller: "Jadi reseller Myfitsociety — tawarkan membership fitnes premium ke pelangganmu.",
      freePremium: "Klaim Myfitsociety Premium gratis — olahraga, program diet, dan meditasi dalam satu aplikasi.",
      challenge: "Ikuti tantangan fitnes Myfitsociety — selesaikan olahraga, naiki leaderboard, dan menangkan hadiah.",
      point: "Kumpulkan poin Myfitsociety dari olahraga dan aktivitas lalu buka reward-nya.",
      packageList: "Pilih paket Myfitsociety — program premium fleksibel untuk olahraga dan diet.",
      businessList: "Jelajahi bisnis yang bermitra dengan Myfitsociety.",
      businessDiscover: "Temukan bisnis dan partner di Myfitsociety.",
      businessDetail: "Profil bisnis di Myfitsociety.",
      collabGetPlan: "Program Myfitsociety-mu sudah siap — lihat program olahraga dan diet yang dibuat untukmu.",
      collabPackageList: "Pilih program Myfitsociety-mu — harga khusus partner.",
    },
    underMaintenance: `Dalam Perbaikan - ${brand.mobile.mfs}`,
    appDownload: `Download Myfitsociety - ${brand.mobile.mfs}`,
    workout: `Olahraga - ${brand.mobile.mfs}`,
  }
};

/**
 * i18n.js advertises defaultLanguage 'en' + otherLanguages ['de','ar','id','zh','pt'],
 * but this dictionary only carries 'en' and 'id'. `seo[language].aboutUs` therefore
 * threw "Cannot read property 'aboutUs' of undefined" during SSR and 500'd the page
 * for de/ar/zh/pt. Read through this accessor instead of indexing `link` directly so
 * the English fallback lives with the data, in one place, instead of at 30-odd call
 * sites that can drift apart.
 */
export const seoFor = (language) => link[language] || link.en;

/**
 * Title for a CMS-backed static page whose heading is the CMS row's own name.
 *
 * pages/page/fluid-static-content.js serves /redeem-1month-free and hardcoded
 * seoFor(lang).privacyPolicy, so the voucher-terms page advertised itself as
 * "Privacy Policy" in the tab (and in search results) for both languages. The
 * CMS row already carries the correct, already-translated name ("How to Redeem
 * Voucher" / "Bagaimana Cara Redeem Voucher"), so build the title from it with
 * the same brand suffix the other static pages use. A missing/empty row name
 * degrades to the brand title, never to an unrelated page's title.
 */
export const staticContentTitle = (name, language, fallbackTitle) => {
  const title = typeof name === "string" ? name.trim() : "";
  if (title) return `${title} - ${brand.mobile.mfs}`;
  const fallback = typeof fallbackTitle === "string" ? fallbackTitle.trim() : "";
  if (fallback) return fallback;
  return seoFor(language).homepage;
};

/**
 * Per-landing-page title/description keyed by the route's page_source
 * (routes/landing-page-*.js). Every public landing URL is supposed to carry a
 * unique title + meta description aligned with its offer instead of reusing the
 * homepage copy verbatim — the SEO guide attached to Trello 507 requires it.
 * Unknown/missing page_source falls back to the homepage strings.
 */
const landing = {
  en: {
    premium: {
      title: `Premium Fitness & Diet Membership - ${brand.mobile.mfs}`,
      desc: "Go Premium for 150+ quick workouts, diet programs, and meditation — all in one app.",
    },
    plan: {
      title: `Choose Your Fitness Plan - ${brand.mobile.mfs}`,
      desc: "Pick the plan that fits your body goals — flexible workout and diet programs.",
    },
    flashdeals: {
      title: `Flash Deals - ${brand.mobile.mfs}`,
      desc: "Limited-time flash deals on premium fitness and diet plans.",
    },
    flashsale: {
      title: `Flash Sale - ${brand.mobile.mfs}`,
      desc: "Flash sale on Myfitsociety premium — workouts, diet programs, and meditation for less.",
    },
    "limited-offer": {
      title: `Limited-Time Offer - ${brand.mobile.mfs}`,
      desc: "A limited-time offer on Myfitsociety premium plans — grab it before it's gone.",
    },
    promo: {
      title: `Special Promo - ${brand.mobile.mfs}`,
      desc: "Special promo pricing on Myfitsociety premium fitness and diet plans.",
    },
    "/deals": {
      title: `Deals - ${brand.mobile.mfs}`,
      desc: "Current deals on Myfitsociety premium workouts and diet programs.",
    },
    "/special": {
      title: `Special Offer - ${brand.mobile.mfs}`,
      desc: "A special offer on Myfitsociety premium — workouts, diet, and meditation in one app.",
    },
    "/redeem": {
      title: `Redeem Your Offer - ${brand.mobile.mfs}`,
      desc: "Redeem your Myfitsociety offer and start your fitness and diet program today.",
    },
    collab: {
      title: `Partner Offer - ${brand.mobile.mfs}`,
      desc: "An exclusive partner offer on Myfitsociety premium plans.",
    },
    diskon: {
      title: `Discount Offer - ${brand.mobile.mfs}`,
      desc: "A special discount on Myfitsociety premium workout and diet plans.",
    },
    hargaspesial: {
      title: `Special Price - ${brand.mobile.mfs}`,
      desc: "Special promo pricing on Myfitsociety premium fitness and diet programs.",
    },
    program: {
      title: `Workout Program - ${brand.mobile.mfs}`,
      desc: "Explore the Myfitsociety workout and diet program and pick the plan that fits you.",
    },
    xt: {
      title: `Start Your Plan - ${brand.mobile.mfs}`,
      desc: "Pick a package and start your personalized fitness program today.",
    },
    quiz: {
      title: `Fitness Quiz - ${brand.mobile.mfs}`,
      desc: "Take the short fitness quiz and get a plan built for your body goals.",
    },
    "questionnaire-v2": {
      title: `Body Goals Quiz - ${brand.mobile.mfs}`,
      desc: "Take the 1-minute quiz and get a workout and diet plan built for your body goals.",
    },
    begin: {
      title: `Begin Your Quiz - ${brand.mobile.mfs}`,
      desc: "Begin the 1-minute quiz and get a workout and diet plan made for you.",
    },
    startnow: {
      title: `Start Now - ${brand.mobile.mfs}`,
      desc: "Start now with a quick quiz and get your personalized fitness plan.",
    },
    join: {
      title: `Join Myfitsociety - ${brand.mobile.mfs}`,
      desc: "Answer a few questions and join Myfitsociety with a plan made for you.",
    },
    build: {
      title: `Build Your Plan - ${brand.mobile.mfs}`,
      desc: "Answer a few questions and build your personalized workout plan.",
    },
    start: {
      title: `Get Started - ${brand.mobile.mfs}`,
      desc: "Get started with a short quiz and get a plan for your body goals.",
    },
    question: {
      title: `Fitness Questions - ${brand.mobile.mfs}`,
      desc: "Answer a few quick questions to get your personalized fitness plan.",
    },
    question2: {
      title: `Quick Fitness Quiz - ${brand.mobile.mfs}`,
      desc: "A few quick questions to build your workout and diet plan.",
    },
    "/promo/beli": {
      title: `Buy Your Plan - ${brand.mobile.mfs}`,
      desc: "Buy your personalized workout and diet plan at promo pricing.",
    },
    "/promo2a": {
      title: `Body Goals Promo - ${brand.mobile.mfs}`,
      desc: "Get your ideal body with a promo workout and diet program from Myfitsociety.",
    },
    "/promo3a": {
      title: `Healthier with Myfitsociety - ${brand.mobile.mfs}`,
      desc: "Feel healthier and more confident with a personalized Myfitsociety program.",
    },
    "promo/quiz": {
      title: `Fitness Quiz Promo - ${brand.mobile.mfs}`,
      desc: "Take the fitness quiz and unlock promo pricing on your plan.",
    },
    "promo/build": {
      title: `Build Your Promo Plan - ${brand.mobile.mfs}`,
      desc: "Build your personalized plan and get promo pricing on Myfitsociety.",
    },
    "promo/startnow": {
      title: `Start Your Promo - ${brand.mobile.mfs}`,
      desc: "Start now — a quick quiz and a promo plan made for you.",
    },
    "promo/start": {
      title: `Start Your Promo Quiz - ${brand.mobile.mfs}`,
      desc: "Start the promo quiz and get a workout and diet plan for your goals.",
    },
    "promo/join": {
      title: `Join the Promo - ${brand.mobile.mfs}`,
      desc: "Join the Myfitsociety promo — a few questions and a plan made for you.",
    },
    "promo/special": {
      title: `Special Promo Quiz - ${brand.mobile.mfs}`,
      desc: "A special promo on your personalized Myfitsociety plan — start with the quiz.",
    },
    "promo/subs1": {
      title: `Subscription Promo 1 - ${brand.mobile.mfs}`,
      desc: "Subscription promo on Myfitsociety premium — answer a few questions to start.",
    },
    "promo/subs2": {
      title: `Subscription Promo 2 - ${brand.mobile.mfs}`,
      desc: "Subscription promo on Myfitsociety premium — answer a few questions to start.",
    },
    "promo/subs3": {
      title: `Subscription Promo 3 - ${brand.mobile.mfs}`,
      desc: "Subscription promo on Myfitsociety premium — answer a few questions to start.",
    },
    "promo/subs4": {
      title: `Subscription Promo 4 - ${brand.mobile.mfs}`,
      desc: "Subscription promo on Myfitsociety premium — answer a few questions to start.",
    },
    "promo/subs5": {
      title: `Subscription Promo 5 - ${brand.mobile.mfs}`,
      desc: "Subscription promo on Myfitsociety premium — answer a few questions to start.",
    },
    "promo/deals": {
      title: `Promo Deals - ${brand.mobile.mfs}`,
      desc: "Take the quiz and get today's promo deals on your Myfitsociety plan.",
    },
    "promo/tr": {
      title: `Your Promo Plan - ${brand.mobile.mfs}`,
      desc: "Answer a few questions and get a promo plan made for your body goals.",
    },
    promo2: {
      title: `Promo Quiz - ${brand.mobile.mfs}`,
      desc: "Take the promo quiz and get a workout plan at special pricing.",
    },
    promo3: {
      title: `Promo Program - ${brand.mobile.mfs}`,
      desc: "A promo on the Myfitsociety workout and diet program — made for you.",
    },
    promo6: {
      title: `Promo Super 6 - ${brand.mobile.mfs}`,
      desc: "Promo Super 6 — a discounted Myfitsociety workout and diet program built for you.",
    },
    promoprice: {
      title: `Promo Pricing - ${brand.mobile.mfs}`,
      desc: "See your promo pricing and pick the Myfitsociety plan that fits you.",
    },
    "plan-pricing": {
      title: `Plan Pricing - ${brand.mobile.mfs}`,
      desc: "Premium workout program plans — pick the one that fits your goals.",
    },
    "premium/quiz": {
      title: `Premium Fitness Quiz - ${brand.mobile.mfs}`,
      desc: "Take the quiz and get a premium workout and diet plan for your goals.",
    },
    "premium/startnow": {
      title: `Start Premium Now - ${brand.mobile.mfs}`,
      desc: "Start your premium plan now — a quick quiz and a program made for you.",
    },
    "premium/build": {
      title: `Build Your Premium Plan - ${brand.mobile.mfs}`,
      desc: "Build your personalized premium workout and diet plan.",
    },
    "premium/start": {
      title: `Start Premium - ${brand.mobile.mfs}`,
      desc: "Start premium with a short quiz and get a plan for your body goals.",
    },
    "premium/join": {
      title: `Join Premium - ${brand.mobile.mfs}`,
      desc: "Join Myfitsociety premium — a few questions and a plan made for you.",
    },
    buy_1_get_1: {
      title: `Buy 1 Get 1 - ${brand.mobile.mfs}`,
      desc: "Buy one get one free on Myfitsociety premium plans — answer a few questions to start.",
    },
    redeem_buy_1_get_1: {
      title: `Redeem Buy 1 Get 1 - ${brand.mobile.mfs}`,
      desc: "Redeem your buy-one-get-one offer and start your Myfitsociety plan.",
    },
    cms: {
      title: `Checkout - ${brand.mobile.mfs}`,
      desc: "Complete your order and start your Myfitsociety plan.",
    },
  },
  id: {
    premium: {
      title: `Membership Fitnes & Diet Premium - ${brand.mobile.mfs}`,
      desc: "Akses Premium ke 150+ olahraga singkat, program diet, dan meditasi dalam satu aplikasi.",
    },
    plan: {
      title: `Pilih Program Fitnesmu - ${brand.mobile.mfs}`,
      desc: "Pilih program yang cocok untuk body goals-mu — program olahraga dan diet yang fleksibel.",
    },
    flashdeals: {
      title: `Flash Deals - ${brand.mobile.mfs}`,
      desc: "Flash deals terbatas untuk program fitnes dan diet premium.",
    },
    flashsale: {
      title: `Flash Sale - ${brand.mobile.mfs}`,
      desc: "Flash sale Myfitsociety premium — olahraga, program diet, dan meditasi lebih hemat.",
    },
    "limited-offer": {
      title: `Penawaran Terbatas - ${brand.mobile.mfs}`,
      desc: "Penawaran terbatas untuk program premium Myfitsociety — klaim sebelum berakhir.",
    },
    promo: {
      title: `Promo Spesial - ${brand.mobile.mfs}`,
      desc: "Harga promo spesial untuk program fitnes dan diet premium Myfitsociety.",
    },
    "/deals": {
      title: `Deals - ${brand.mobile.mfs}`,
      desc: "Promo terkini untuk program olahraga dan diet premium Myfitsociety.",
    },
    "/special": {
      title: `Penawaran Spesial - ${brand.mobile.mfs}`,
      desc: "Penawaran spesial Myfitsociety premium — olahraga, diet, dan meditasi dalam satu aplikasi.",
    },
    "/redeem": {
      title: `Klaim Penawaranmu - ${brand.mobile.mfs}`,
      desc: "Klaim penawaran Myfitsociety-mu dan mulai program fitnes dan diet hari ini.",
    },
    collab: {
      title: `Penawaran Partner - ${brand.mobile.mfs}`,
      desc: "Penawaran eksklusif partner untuk program premium Myfitsociety.",
    },
    diskon: {
      title: `Penawaran Diskon - ${brand.mobile.mfs}`,
      desc: "Diskon spesial untuk program olahraga dan diet premium Myfitsociety.",
    },
    hargaspesial: {
      title: `Harga Spesial - ${brand.mobile.mfs}`,
      desc: "Harga promo spesial untuk program fitnes dan diet premium Myfitsociety.",
    },
    program: {
      title: `Program Olahraga - ${brand.mobile.mfs}`,
      desc: "Jelajahi program olahraga dan diet Myfitsociety lalu pilih plan yang cocok untukmu.",
    },
    xt: {
      title: `Mulai Programmu - ${brand.mobile.mfs}`,
      desc: "Pilih paket dan mulai program fitnes personalmu hari ini.",
    },
    quiz: {
      title: `Kuis Fitnes - ${brand.mobile.mfs}`,
      desc: "Ikuti kuis fitnes singkat dan dapatkan program untuk body goals-mu.",
    },
    "questionnaire-v2": {
      title: `Kuis Body Goals - ${brand.mobile.mfs}`,
      desc: "Isi kuis 1 menit dan dapatkan program olahraga dan diet yang dibuat untuk body goals-mu.",
    },
    begin: {
      title: `Mulai Kuismu - ${brand.mobile.mfs}`,
      desc: "Mulai kuis 1 menit dan dapatkan program olahraga dan diet untukmu.",
    },
    startnow: {
      title: `Mulai Sekarang - ${brand.mobile.mfs}`,
      desc: "Mulai sekarang dengan kuis singkat dan dapatkan program fitnes personalmu.",
    },
    join: {
      title: `Gabung Myfitsociety - ${brand.mobile.mfs}`,
      desc: "Jawab beberapa pertanyaan dan gabung Myfitsociety dengan program yang dibuat untukmu.",
    },
    build: {
      title: `Susun Programmu - ${brand.mobile.mfs}`,
      desc: "Jawab beberapa pertanyaan dan susun program olahraga personalmu.",
    },
    start: {
      title: `Ayo Mulai - ${brand.mobile.mfs}`,
      desc: "Mulai dengan kuis singkat dan dapatkan program untuk body goals-mu.",
    },
    question: {
      title: `Pertanyaan Fitnes - ${brand.mobile.mfs}`,
      desc: "Jawab beberapa pertanyaan singkat untuk mendapatkan program fitnes personalmu.",
    },
    question2: {
      title: `Kuis Fitnes Singkat - ${brand.mobile.mfs}`,
      desc: "Beberapa pertanyaan singkat untuk menyusun program olahraga dan dietmu.",
    },
    "/promo/beli": {
      title: `Beli Programmu - ${brand.mobile.mfs}`,
      desc: "Beli program olahraga dan diet personalmu dengan harga promo.",
    },
    "/promo2a": {
      title: `Promo Badan Ideal - ${brand.mobile.mfs}`,
      desc: "Dapatkan badan ideal dengan program olahraga dan diet promo dari Myfitsociety.",
    },
    "/promo3a": {
      title: `Lebih Sehat Bersama Myfitsociety - ${brand.mobile.mfs}`,
      desc: "Lebih sehat dan percaya diri dengan program Myfitsociety yang personal.",
    },
    "promo/quiz": {
      title: `Kuis Fitnes Promo - ${brand.mobile.mfs}`,
      desc: "Ikuti kuis fitnes dan dapatkan harga promo untuk programmu.",
    },
    "promo/build": {
      title: `Susun Program Promomu - ${brand.mobile.mfs}`,
      desc: "Susun program personalmu dan dapatkan harga promo Myfitsociety.",
    },
    "promo/startnow": {
      title: `Mulai Promo Sekarang - ${brand.mobile.mfs}`,
      desc: "Mulai sekarang — kuis singkat dan program promo yang dibuat untukmu.",
    },
    "promo/start": {
      title: `Mulai Kuis Promo - ${brand.mobile.mfs}`,
      desc: "Mulai kuis promo dan dapatkan program olahraga dan diet untuk goals-mu.",
    },
    "promo/join": {
      title: `Ikuti Promo - ${brand.mobile.mfs}`,
      desc: "Ikuti promo Myfitsociety — beberapa pertanyaan dan program yang dibuat untukmu.",
    },
    "promo/special": {
      title: `Kuis Promo Spesial - ${brand.mobile.mfs}`,
      desc: "Promo spesial untuk program Myfitsociety personalmu — mulai dari kuis.",
    },
    "promo/subs1": {
      title: `Promo Langganan 1 - ${brand.mobile.mfs}`,
      desc: "Promo langganan Myfitsociety premium — jawab beberapa pertanyaan untuk mulai.",
    },
    "promo/subs2": {
      title: `Promo Langganan 2 - ${brand.mobile.mfs}`,
      desc: "Promo langganan Myfitsociety premium — jawab beberapa pertanyaan untuk mulai.",
    },
    "promo/subs3": {
      title: `Promo Langganan 3 - ${brand.mobile.mfs}`,
      desc: "Promo langganan Myfitsociety premium — jawab beberapa pertanyaan untuk mulai.",
    },
    "promo/subs4": {
      title: `Promo Langganan 4 - ${brand.mobile.mfs}`,
      desc: "Promo langganan Myfitsociety premium — jawab beberapa pertanyaan untuk mulai.",
    },
    "promo/subs5": {
      title: `Promo Langganan 5 - ${brand.mobile.mfs}`,
      desc: "Promo langganan Myfitsociety premium — jawab beberapa pertanyaan untuk mulai.",
    },
    "promo/deals": {
      title: `Promo Deals - ${brand.mobile.mfs}`,
      desc: "Ikuti kuis dan dapatkan promo deals hari ini untuk program Myfitsociety-mu.",
    },
    "promo/tr": {
      title: `Program Promomu - ${brand.mobile.mfs}`,
      desc: "Jawab beberapa pertanyaan dan dapatkan program promo untuk body goals-mu.",
    },
    promo2: {
      title: `Kuis Promo - ${brand.mobile.mfs}`,
      desc: "Ikuti kuis promo dan dapatkan program olahraga dengan harga spesial.",
    },
    promo3: {
      title: `Program Promo - ${brand.mobile.mfs}`,
      desc: "Promo untuk program olahraga dan diet Myfitsociety — dibuat untukmu.",
    },
    promo6: {
      title: `Promo Super 6 - ${brand.mobile.mfs}`,
      desc: "Promo Super 6 — program olahraga dan diet Myfitsociety dengan diskon untukmu.",
    },
    promoprice: {
      title: `Harga Promo - ${brand.mobile.mfs}`,
      desc: "Lihat harga promomu dan pilih program Myfitsociety yang cocok.",
    },
    "plan-pricing": {
      title: `Harga Program - ${brand.mobile.mfs}`,
      desc: "Program olahraga premium — pilih yang cocok untuk goals-mu.",
    },
    "premium/quiz": {
      title: `Kuis Fitnes Premium - ${brand.mobile.mfs}`,
      desc: "Ikuti kuis dan dapatkan program olahraga dan diet premium untuk goals-mu.",
    },
    "premium/startnow": {
      title: `Mulai Premium Sekarang - ${brand.mobile.mfs}`,
      desc: "Mulai program premiummu sekarang — kuis singkat dan program yang dibuat untukmu.",
    },
    "premium/build": {
      title: `Susun Program Premium - ${brand.mobile.mfs}`,
      desc: "Susun program olahraga dan diet premium personalmu.",
    },
    "premium/start": {
      title: `Mulai Premium - ${brand.mobile.mfs}`,
      desc: "Mulai premium dengan kuis singkat dan dapatkan program untuk body goals-mu.",
    },
    "premium/join": {
      title: `Gabung Premium - ${brand.mobile.mfs}`,
      desc: "Gabung Myfitsociety premium — beberapa pertanyaan dan program yang dibuat untukmu.",
    },
    buy_1_get_1: {
      title: `Beli 1 Gratis 1 - ${brand.mobile.mfs}`,
      desc: "Beli 1 gratis 1 untuk program premium Myfitsociety — jawab beberapa pertanyaan untuk mulai.",
    },
    redeem_buy_1_get_1: {
      title: `Klaim Beli 1 Gratis 1 - ${brand.mobile.mfs}`,
      desc: "Klaim penawaran beli 1 gratis 1-mu dan mulai program Myfitsociety.",
    },
    cms: {
      title: `Checkout - ${brand.mobile.mfs}`,
      desc: "Selesaikan pesananmu dan mulai program Myfitsociety.",
    },
  },
};

export const landingSeoFor = (language, pageSource) => {
  const dict = landing[language] || landing.en;
  const base = seoFor(language);
  const entry = dict[pageSource];
  return {
    title: (entry && entry.title) || base.homepage,
    desc: (entry && entry.desc) || (base.desc && base.desc.homepage) || "",
  };
};

/**
 * Quiz funnel pages (questionnaire-v2) — one honest title/description for the
 * workout quiz whatever promo URL it is entered through.
 */
export const quizSeoFor = (language) => {
  if (language === "id") {
    return {
      title: `Kuis Body Goals - ${brand.mobile.mfs}`,
      desc: "Isi kuis 1 menit dan dapatkan program olahraga dan diet yang dibuat untuk body goals-mu.",
    };
  }
  return {
    title: `Body Goals Quiz - ${brand.mobile.mfs}`,
    desc: "Take the 1-minute quiz and get a workout and diet plan built for your body goals.",
  };
};

export default link;
